import { SpectraConfig } from './types';

const defaultState: SpectraConfig = {
    databilities: [
        {
            _radius: 1000,
            id: Math.random().toString(),
            datasetId: '',
            capabilityId: 'specden',
            timeRange: 'PT0S--P5DT0S',
            data_structure: 'timeseries/point2d',
        },
    ],
    settings: {
        title: '',
        fontSize: 100,
        xDimensionalVariable: 'time',
        yDimensionalVariable: 'freq',
        blur: 3,
        yAxisDecimalPlaces: 1,
        displayLegend: true,
        displayGrid: true,
        displayTimeLegend: true,
    },
};

export default defaultState;
